import axios from 'axios';

import {BASE_TRANSLATION_APP_URL, LOCALE} from '../config';

const translationsAxios = axios.create({
  baseURL: `${BASE_TRANSLATION_APP_URL}tlumaczenia/get/${LOCALE}`,
});
export default translationsAxios;
